<template>
	<apexchart
		type="bar"
		height="500"
		:series="series"
		:options="chartOptions"
	/>
</template>

<script>
export default {
	name: 'BaseStackedBarChart',

	props: {
		series: {
			type: Array,
			required: true,
		},
		categories: {
			type: Array,
			required: true,
		},
		colors: {
			type: Array,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		showLegend: {
			type: Boolean,
			default: true,
		},
		yaxisMax: {
			type: Number,
			required: false,
		},
	},

	computed: {
		chartOptions() {
			return {
				grid: { show: false },
				colors: this.colors,
				title: {
					text: this.title,
					align: 'left',
					style: {
						fontSize: '16px',
						fontFamily: 'undefined',
						color: '#475569',
						font: '600',
					},
				},
				chart: {
					type: 'bar',
					stacked: true,
					toolbar: { show: true },
					zoom: { enabled: true },
				},
				plotOptions: {
					bar: {
						dataLabels: {
							position: 'top',
							total: {
								enabled: false,
								style: {
									fontSize: '13px',
									fontWeight: 900,
								},
							},
						},
					},
				},
				dataLabels: {
					enabled: true,
					formatter: function (val, opts) {
						const chartHeight = opts.w.globals.gridHeight;
						const maxValue = opts.w.globals.maxY;
						const barHeight = (val / maxValue) * chartHeight;
						if (barHeight < 15) {
							return '';
						}
						console.log('val', val);
						return val;
					},
				},
				xaxis: {
					categories: this.categories,
					crosshairs: {
						show: false,
					},
					labels: {
						formatter: function (value) {
							const MAX_LENGTH = 20;
							if (!value) return '';
							return value.length > MAX_LENGTH
								? value.substring(0, MAX_LENGTH) + '…'
								: value;
						},
					},
				},
				yaxis: {
					max: this.yaxisMax,
				},
				legend: {
					show: this.showLegend,
					position: 'bottom',
					itemMargin: {
						horizontal: 10,
						vertical: 20,
					},
				},
				fill: { opacity: 1 },
			};
		},
	},
};
</script>
